import { Button, Typography } from "@suraasa/placebo-ui"
import clsx from "clsx"
import { differenceInDays, isAfter } from "date-fns"
import { useState } from "react"
import { pluralize } from "utils/helpers"

import FreeTrialDarkGradient from "../assets/free-trial-gradient-dark.webp"
import FreeTrialLightGradient from "../assets/free-trial-gradient-light.webp"
import SuraasaPlusGradientButton from "../components/GradientButton/SuraasaPlusGradientButton"
import SuraasaPlusLogo, { LogoVariant } from "../components/SuraasaPlusLogo"
import { useSuraasaPlusContext } from "../context"
import { getFreeTrialConfig } from "./helper"

const FreeTrialCard = ({ gradient = true, className = "" }) => {
  const { subscriptionDetails, initiateSuraasaPlusPurchaseFlow } =
    useSuraasaPlusContext()

  const validThrough = subscriptionDetails?.subscription?.validThrough
  const [now] = useState(() => Date.now())

  if (!subscriptionDetails?.subscription.isFreeClaim || !validThrough)
    return null

  const freeTrialHasEnded = isAfter(now, new Date(validThrough))
  const daysLeft = differenceInDays(new Date(validThrough), new Date())
  const freeTrialIsAboutToEnd = !freeTrialHasEnded && daysLeft <= 3

  const styleConfig = getFreeTrialConfig({
    freeTrialHasEnded: freeTrialHasEnded,
  })

  const title = freeTrialHasEnded
    ? "Your free trial has ended"
    : `Your free trial ends in ${pluralize("day", daysLeft)}`

  if (freeTrialHasEnded || freeTrialIsAboutToEnd)
    return (
      <div
        className={clsx(
          "relative mb-2.5 overflow-hidden rounded-2xl p-2.5 md:p-3",
          styleConfig.background,
          className
        )}
      >
        {gradient && (
          <div className="absolute -left-8 -top-0 z-0 md:-left-16">
            <img
              className="h-15 w-full md:max-h-15"
              src={
                freeTrialHasEnded
                  ? FreeTrialDarkGradient
                  : FreeTrialLightGradient
              }
              alt="free-trial"
            />
          </div>
        )}
        <div className="z-10 flex flex-col items-start justify-between gap-2.5 md:flex-row md:items-center md:gap-0">
          <div className="flex flex-col">
            <div className="mb-1">
              <SuraasaPlusLogo
                color={styleConfig.logoColor}
                height={17.18}
                width={36}
                variant={LogoVariant.plus}
              />
            </div>
            <Typography
              className={clsx(styleConfig.titleClassName)}
              variant="title4"
            >
              {title}
            </Typography>
            <Typography
              variant="smallBody"
              className={clsx(styleConfig.subtitleClassName)}
            >
              Upgrade now to keep saving time with AI tools built for teachers.
            </Typography>
          </div>

          {freeTrialHasEnded ? (
            <Button
              onClick={() => initiateSuraasaPlusPurchaseFlow()}
              className="w-fit whitespace-nowrap bg-white px-1.5 py-[7px] text-onSurface-900"
            >
              Get Suraasa Plus
            </Button>
          ) : (
            <SuraasaPlusGradientButton logoHeight={18.2} logoWidth={87} />
          )}
        </div>
      </div>
    )
}

export default FreeTrialCard
